module.exports = __webpack_public_path__ + "static/media/12.9cbc4bc2.jpeg";